import React, { useEffect, useRef, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Col, Row, Card, UncontrolledPopover, PopoverBody } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import action from "../../../assets/icons/action.svg"
import { toastSuccess } from "../../../helpers/msg_helper"
import { Link, useLocation, useNavigate } from "react-router-dom"
import {
  fetchHrmsGradeControl,
  updateGradeControlStatus,
} from "../../../services/Hrms/hrms"
import capitalizeFirstLetter from "../../../utils/capitalizeFirstLetter"
import {
  deleteManufacturingJournal,
  downloadManufacture,
  searchManufacturingJournal,
  updateManufactureJournal,
} from "../../../services/finance/finance"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import ManufaturingLedgerFilter from "./filter"
import moment from "moment"
import NumberFormat from "../../../utils/numberFormat"
import LogoutPopup from "../../../components/VerticalLayout/logoutpopup"

const ManufacturingJournal = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Manufacturing Journal${companyname ? ` | ${companyname}` : 'MEP -Hub'}`;

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  const navigate = useNavigate()
  const [refresh, setRefresh] = useState(0)
  const [classData, setClassData] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [country, setCountry] = useState("")
  const [page, setPage] = useState("")
  const [dataPerPage, setDataPerPage] = useState(25)
  const [logoutModal, setLogoutModal] = useState(false)
  const [deleteId, setDeleteId] = useState("")

  const handleActivate = item => {
    const updateStatus = async item => {
      const response = await updateGradeControlStatus(item)
      toastSuccess(response?.message)
      setRefresh(refresh + 1)
    }
    updateStatus(item)
  }

  const handleDelete = async id => {
    const responce = await deleteManufacturingJournal(id)
    toastSuccess(responce?.message)
    setRefresh(refresh + 1)
  }

  const handilRest = () => {
    setRefresh(refresh + 1)
  }

  const handleUpdateStatus = async (id, dt) => {
    const data = { id: id, status: dt }
    const responce = await updateManufactureJournal(data)
    toastSuccess(responce?.message)
    setRefresh(refresh + 1)
  }

  const columns = [
    {
      label: "Code",
      renderCell: item => {
        return (
          <div
            onClick={() =>
              navigate(`/finance-manufacturing-journal/view/${item?.id}`, {state: {name: crumb}})
            }
            className="pointer fw-bold"
          >
            {item?.code ? item?.code : "-"}
          </div>
        )
      },
    },
    {
      label: "Project Code",
      renderCell: item => {
        return (
          <div
          // onClick={() =>
          //   navigate(`/finance-ledger-acc`, {
          //     state: item,
          //   })
          // }
          // className="pointer fw-bold"
          >
            {item?.project ? item?.project?.project_code : "-"}
          </div>
        )
      },
    },
    {
      label: "Date",
      renderCell: item =>
        item?.date ? moment(item?.date).format("DD-MMM-YYYY") : "-",
    },
    {
      label: <div className="text-end pe-5">Amount (AED)</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(item?.grand_with_total || 0, desimalrange, desimalrange)}
        </div>
      ),
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <div
            className={`font-13 ${item?.status === 1
                ? "status-active"
                : item?.status === 2
                  ? "status-inactive"
                  : "status-draft"
              }`}
          >
            {item?.status === 1
              ? "Approved"
              : item?.status === 2
                ? "Rejected"
                : "New"}
          </div>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              {loggedUser?.permission?.some(
                permissionItem => permissionItem?.name === "ledger_edit"
              ) &&
                item?.status == 0 && (
                  <>
                    <div
                      className="table-popup-content"
                      onClick={() =>
                        navigate(
                          `/finance-manufacturing-journal/edit/${item?.id}`
                        )
                      }
                    >
                      Edit
                    </div>
                    <div
                      className="table-popup-content"
                      onClick={() => handleUpdateStatus(item?.id, 1)}
                    >
                      Approve
                    </div>
                    <div
                      className="table-popup-content"
                      onClick={() => handleUpdateStatus(item?.id, 2)}
                    >
                      Reject
                    </div>
                  </>
                )}
              {loggedUser?.permission?.some(
                permissionItem => permissionItem?.name === "ledger_edit"
              ) && (
                  <>
                    <div
                      className="table-popup-content"
                      // onClick={() => handleDelete(item?.id)}
                      onClick={e => {
                        e.preventDefault()
                        setLogoutModal(true)
                        setDeleteId(item?.id)
                      }}
                    >
                      Delete
                    </div>
                  </>
                )}
              <div
                className="table-popup-content"
                onClick={() => downloadManufacture(item?.id, "progress.pdf")}
              >
                Download
              </div>
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  useEffect(() => {
    const fetchClass = async () => {
      const response = await searchManufacturingJournal({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${search ? `&searchText=${search}` : "searchText"
          }${`&sortOrder=asc`}${country ? `&country_id=${country}` : ""}${page ? `&page=${page}` : ""
          }${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      // setClassData(response)
      const newData = response?.data || [];

      setClassData(prev =>
        page > 1 && prev
          ? {
            ...response,
              data: [...(prev.data || []), ...newData],
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchClass()
  }, [refresh, status, search, country, page, dataPerPage])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < classData?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [classData, page]);

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleCountryChange = id => {
    setCountry(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Procurement"
              breadcrumbObject={[
                { title: "Finance", link: "/finance" },
                { title: crumb || "Inventory Vouchers", link: "/finance" },
                {
                  title: "Manufacturing Journals",
                  link: "/finance-manufacturing-journal",
                },
              ]}
            />
            {loggedUser?.permission?.some(
              permissionItem => permissionItem?.name === "ledger_create"
            ) && (
                <Link
                  to="/finance-manufacturing-journal/add"
                  state={{ menuLabel: crumb }}
                  className={"px-2 mb-3 me-2 btn btn-primary"}
                >
                  {"+ Manufacturing Journal"}
                </Link>
              )}
          </div>
          <Card className="me-2 px-2 pb-2">
            <ManufaturingLedgerFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleCountryChange={handleCountryChange}
              sampleUrl={"download/suppliers.xlsx"}
              importUrl={"suppliers/import"}
              isImport={false}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
              <div ref={tableContainerRef} style={{ maxHeight: "490px", overflowY: "auto" }}>
                {classData && (
                  <UpdateTable
                    className="mt-5"
                    nodes={classData?.data}
                    paginate={classData}
                    columns={columns}
                    CurrentPage={page}
                    handlePagination={handlePaginate}
                    handleSizePerPage={handleSizePerPageChange}
                    tableWidth="20% 20% 20% 20% 10% 10%"
                    mobileWidth="40% 40% 40% 40% 40% 20%"
                    isLoading={isLoadingNextPage}
                    hidePaginate={true}
                  />
                )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
      <LogoutPopup
        isOpen={logoutModal}
        toggle={() => setLogoutModal(!logoutModal)}
        ManufacturingJournal={true}
        deleteId={deleteId}
        handilRest={handilRest}
      />
    </React.Fragment>
  )
}

export default ManufacturingJournal
